export default __webpack_public_path__ + "static/icon-31-5-caa000dfa3cded7022dddf02fa08b399.png";